export default __webpack_public_path__ + "static/media/actively-hiring.8f509f26.svg";